import { render, staticRenderFns } from "./seed_treatment.vue?vue&type=template&id=e964df82&"
import script from "./seed_treatment.vue?vue&type=script&lang=js&"
export * from "./seed_treatment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports